import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { QuestionBase } from './models/question/question-base';
import { NumPadComponent } from '@app/shared/common/num-pad/num-pad.component';
import { FormGroup } from '@angular/forms';
declare var $;

@Injectable()
export class CalculatorPopupService {
    constructor(private injector: Injector,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver) { }

        addNumpadContentToModal(form: FormGroup, question: QuestionBase<any>, targetEl: HTMLElement) {
        // Create element
        const numpad = document.createElement('numpad-component');

        // Create the component and wire it up with the element
        const factory = this.componentFactoryResolver.resolveComponentFactory(NumPadComponent);
        const numpadComponentRef = factory.create(this.injector, [], numpad);

        // Attach to the view so that the change detector knows to run
        this.applicationRef.attachView(numpadComponentRef.hostView);

        // Set component content
        numpadComponentRef.instance.question = question;
        numpadComponentRef.instance.form = form;

        // Add to the DOM
        $(targetEl).append(numpad);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/calculator-popup.service.ts